<template>
  <div>
    <v-row no-gutters align="center" justify="center">
      <v-container class="mx-auto">
        <div class="height-spacer"></div>
        <div class="mx-4">
          <h1 class="h36-medium white--text ml-3">
            {{ $t("homepage.login.right.title") }}
          </h1>
        </div>
        <v-card-text class="form">
          <v-col sm="12">
            <v-form ref="loginForm" v-model="loginValid" lazy-validation>
              <v-text-field
                dark
                v-model="username"
                :label="$t('homepage.login.right.form.username')"
                :rules="[rules.required]"
                color="white"
                @keyup.enter="login"
              ></v-text-field>
              <v-text-field
                dark
                v-model="password"
                :label="$t('homepage.login.right.form.password')"
                :append-icon="showPassword ? 'fas fa-eye' : 'fas fa-eye-slash'"
                :type="showPassword ? 'text' : 'password'"
                :rules="[rules.required]"
                validate-on-blur
                counter
                color="white"
                @keyup.enter="login"
                @click:append="showPassword = !showPassword"
              ></v-text-field>
            </v-form>
          </v-col>
        </v-card-text>
        <v-card-actions>
          <v-col sm="12">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <v-btn
                id="buttonaccedi"
                class="mr-2 mb-2 px-7 importantbutton"
                color="primary"
                rounded
                :disabled="!loginValid"
                @click="login"
              >
                <span>{{ $t("homepage.login.right.btns.login") }}</span>
              </v-btn>
            </v-row>
          </v-col>
        </v-card-actions>
        <v-card-actions>
          <v-col sm="12" class="py-0">
            <v-row align="center" justify="center">
              <v-btn
                id="forgotpassbtn"
                class="ml-0 mr-2 mb-4"
                @click="goToForgotPassword"
                rounded
                outlined
                color="white"
              >
                {{ $t("homepage.login.right.form.forgotPasswordButtonLabel") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-card-actions>
        <v-card-actions>
          <v-col sm="12" class="py-0">
            <v-row align="center" justify="center">
              <v-btn
                id="forgotuserbtn"
                class="ml-0 mr-2 mb-4"
                @click="goToForgotUsername"
                rounded
                outlined
                color="white"
              >
                <span>
                  {{
                    $t("homepage.login.right.form.forgotUsernameButtonLabel")
                  }}
                </span>
              </v-btn>
            </v-row>
          </v-col>
        </v-card-actions>
        <!-- <v-divider id="divider" class="my-5"></v-divider>
        <v-card-actions id="spaceregistred" class="ml-4">
          <v-row no-gutters>
            <v-toolbar
              flat
              class="layout my-button-toolbar"
              text
              style="background-color: transparent"
            >
              <v-toolbar-title
                id="titlenotreg"
                class="my-v-toolbar__title-inherit font-weight-light white--text"
              >
                {{ $t("homepage.not-register") }}
                <v-btn
                  id="notregistredbtn"
                  class="ml-0 mr-1 importantbutton"
                  rounded
                  @click="goToAgreementRequest"
                  >{{ $t("homepage.request-agreement") }}</v-btn
                >
              </v-toolbar-title>
            </v-toolbar>
          </v-row>
        </v-card-actions> -->
      </v-container>
    </v-row>
    <v-row no-gutters>
      <v-container class="mx-auto">
        <v-row
          no-gutters
          justify="end"
          class="caption font-weight-bold font-italic white--text"
        >
          {{ $t("version") }}&#58;&nbsp;{{ version }}
        </v-row>
      </v-container></v-row
    >
  </div>
</template>

<script>
import ValidationRules from "../../views/validationRules";
let vrules = new ValidationRules();

export default {
  data() {
    return {
      username: "",
      password: "",
      showPassword: false,
      loginValid: true,
      rules: vrules,
      errorHeadline: "dialog.error.cardTitle",
      closeErrorButtonText: "dialog.error.closeButtonLabel",
      version: process.env.VUE_APP_VERSION,
      isProductionEnv: process.env.NODE_ENV === "production",
      portaleConvenzioniUrl: process.env.VUE_APP_PORTALE_CONVENZIONI_URL
    };
  },
  computed: {
    errorDialog() {
      return this.$store.getters["error/errorDialog"];
    },
    loadingDialog() {
      return this.$store.getters["loading/loadingDialog"];
    }
  },
  created() {
    this.$store.commit("error/RESET");
    this.$store.commit("auth/setIncomingForSla", null, { root: true });
    let officeId = this.$route.params.hfOfficeId;
    let redirectType = this.$route.params.redirectType;
    let slaType = this.$route.params.slaType;
    if (officeId && redirectType && slaType) {
      this.$store.commit(
        "auth/setIncomingForSla",
        { officeId: officeId, slaType: slaType, redirectType: redirectType },
        { root: true }
      );
    }
  },
  methods: {
    goToAgreementRequest() {
      window.location.href =
        this.portaleConvenzioniUrl.concat("/agreementRequest");
    },
    goToForgotUsername() {
      this.$router.push({
        name: "usernameRecovery"
      });
    },
    goToForgotPassword() {
      this.$router.push({
        name: "passwordRecovery"
      });
    },
    login() {
      if (this.$refs.loginForm.validate()) {
        this.$store.dispatch("auth/login", {
          username: this.username,
          password: this.password
        });
      }
    },
    closeErrorDialog() {
      this.$store.commit("error/RESET");
    }
  }
};
</script>

<style scoped>
/*  Start Responsive screen + Specific Mobile & Tablets */

@media only screen and (min-width: 1527px) {
  #buttonaccedi {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 12px !important;
    margin-left: 55px !important;
  }

  #forgotpassbtn {
    padding-left: 102px !important;
    padding-right: 110px !important;
    margin-left: 15px !important;
  }

  #forgotuserbtn {
    padding-left: 105px !important;
    padding-right: 105px !important;
    margin-left: 14px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #notregistredbtn {
    margin-bottom: 18px !important;
    margin-left: 2px !important;
    padding-left: 13px !important;
    padding-right: 13px !important;
  }
}

@media screen and (max-width: 1526px) and (min-width: 1524px) {
  #buttonaccedi {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 10px !important;
    margin-left: 55px !important;
  }

  #forgotpassbtn {
    padding-left: 102px !important;
    padding-right: 110px !important;
    margin-left: 15px !important;
  }

  #forgotuserbtn {
    padding-left: 105px !important;
    padding-right: 105px !important;
    margin-left: 14px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #notregistredbtn {
    margin-bottom: 20px !important;
    margin-left: 2px !important;
    padding-left: 13px !important;
    padding-right: 13px !important;
  }
}

@media screen and (max-width: 1524px) and (min-width: 1513px) {
  #buttonaccedi {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 10px !important;
    margin-left: 55px !important;
  }

  #forgotpassbtn {
    padding-left: 102px !important;
    padding-right: 110px !important;
    margin-left: 15px !important;
  }

  #forgotuserbtn {
    padding-left: 105px !important;
    padding-right: 105px !important;
    margin-left: 14px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #notregistredbtn {
    margin-bottom: 20px !important;
    margin-left: 2px !important;
    padding-left: 11px !important;
    padding-right: 11px !important;
  }
}

@media screen and (max-width: 1512px) and (min-width: 1509px) {
  #buttonaccedi {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 10px !important;
    margin-left: 55px !important;
  }

  #forgotpassbtn {
    padding-left: 102px !important;
    padding-right: 110px !important;
    margin-left: 15px !important;
  }

  #forgotuserbtn {
    padding-left: 105px !important;
    padding-right: 105px !important;
    margin-left: 14px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #notregistredbtn {
    margin-bottom: 20px !important;
    margin-left: 2px !important;
    padding-left: 10px !important;
    padding-right: 10px !important;
  }
}

@media screen and (max-width: 1508px) and (min-width: 1504px) {
  #buttonaccedi {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 10px !important;
    margin-left: 55px !important;
  }

  #forgotpassbtn {
    padding-left: 102px !important;
    padding-right: 110px !important;
    margin-left: 15px !important;
  }

  #forgotuserbtn {
    padding-left: 105px !important;
    padding-right: 105px !important;
    margin-left: 14px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #notregistredbtn {
    margin-bottom: 20px !important;
    margin-left: 1px !important;
    padding-left: 10px !important;
    padding-right: 10px !important;
  }
}

@media screen and (max-width: 1503px) and (min-width: 1500px) {
  #buttonaccedi {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 10px !important;
    margin-left: 55px !important;
  }

  #forgotpassbtn {
    padding-left: 102px !important;
    padding-right: 110px !important;
    margin-left: 15px !important;
  }

  #forgotuserbtn {
    padding-left: 105px !important;
    padding-right: 105px !important;
    margin-left: 14px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #notregistredbtn {
    margin-bottom: 20px !important;
    margin-left: 1px !important;
    padding-left: 9px !important;
    padding-right: 9px !important;
  }
}

@media screen and (max-width: 1499px) and (min-width: 1494px) {
  #buttonaccedi {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 10px !important;
    margin-left: 55px !important;
  }

  #forgotpassbtn {
    padding-left: 102px !important;
    padding-right: 110px !important;
    margin-left: 15px !important;
  }

  #forgotuserbtn {
    padding-left: 105px !important;
    padding-right: 105px !important;
    margin-left: 14px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #notregistredbtn {
    margin-bottom: 20px !important;
    margin-left: 1px !important;
    padding-left: 8.5px !important;
    padding-right: 8.5px !important;
  }
}

@media screen and (max-width: 1494px) and (min-width: 1480px) {
  #buttonaccedi {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 10px !important;
    margin-left: 55px !important;
  }

  #forgotpassbtn {
    padding-left: 102px !important;
    padding-right: 110px !important;
    margin-left: 15px !important;
  }

  #forgotuserbtn {
    padding-left: 105px !important;
    padding-right: 105px !important;
    margin-left: 14px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #notregistredbtn {
    margin-bottom: 20px !important;
    margin-left: 1px !important;
    padding-left: 6px !important;
    padding-right: 6px !important;
  }
}

@media screen and (max-width: 1480px) and (min-width: 1477px) {
  #buttonaccedi {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 10px !important;
    margin-left: 55px !important;
  }

  #forgotpassbtn {
    padding-left: 102px !important;
    padding-right: 110px !important;
    margin-left: 15px !important;
  }

  #forgotuserbtn {
    padding-left: 105px !important;
    padding-right: 105px !important;
    margin-left: 14px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #notregistredbtn {
    margin-bottom: 20px !important;
    margin-left: 1px !important;
    padding-left: 5.5px !important;
    padding-right: 5.5px !important;
  }
}

@media screen and (max-width: 1477px) and (min-width: 1473px) {
  #buttonaccedi {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 10px !important;
    margin-left: 55px !important;
  }

  #forgotpassbtn {
    padding-left: 102px !important;
    padding-right: 110px !important;
    margin-left: 15px !important;
  }

  #forgotuserbtn {
    padding-left: 105px !important;
    padding-right: 105px !important;
    margin-left: 14px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #notregistredbtn {
    margin-bottom: 20px !important;
    margin-left: 1px !important;
    padding-left: 5px !important;
    padding-right: 5px !important;
  }
}

@media screen and (max-width: 1472px) and (min-width: 1400px) {
  #buttonaccedi {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 0px !important;
    margin-left: 55px !important;
  }

  #forgotpassbtn {
    padding-left: 102px !important;
    padding-right: 110px !important;
    margin-left: 15px !important;
  }

  #forgotuserbtn {
    padding-left: 105px !important;
    padding-right: 105px !important;
    margin-left: 14px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #notregistredbtn {
    margin-bottom: 20px !important;
    margin-left: 0.1px !important;
    margin-top: 10px !important;
    padding-left: 90px !important;
    padding-right: 90px !important;
  }
}

@media screen and (max-width: 1399px) and (min-width: 1380px) {
  #buttonaccedi {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 0px !important;
    margin-left: 55px !important;
  }

  #forgotpassbtn {
    padding-left: 102px !important;
    padding-right: 110px !important;
    margin-left: 15px !important;
  }

  #forgotuserbtn {
    padding-left: 105px !important;
    padding-right: 105px !important;
    margin-left: 14px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #notregistredbtn {
    margin-bottom: 20px !important;
    margin-top: 10px !important;
    padding-left: 88px !important;
    padding-right: 88px !important;
  }
}

@media screen and (max-width: 1380px) and (min-width: 1340px) {
  #buttonaccedi {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 0px !important;
    margin-left: 55px !important;
  }

  #forgotpassbtn {
    padding-left: 102px !important;
    padding-right: 110px !important;
    margin-left: 15px !important;
  }

  #forgotuserbtn {
    padding-left: 105px !important;
    padding-right: 105px !important;
    margin-left: 14px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #notregistredbtn {
    margin-bottom: 20px !important;
    margin-top: 10px !important;
    padding-left: 85px !important;
    padding-right: 85px !important;
  }

  #spaceregistred {
    margin-left: 10px !important;
  }
}

@media screen and (max-width: 1340px) and (min-width: 1300px) {
  #buttonaccedi {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 0px !important;
    margin-left: 55px !important;
  }

  #forgotpassbtn {
    padding-left: 102px !important;
    padding-right: 110px !important;
    margin-left: 15px !important;
  }

  #forgotuserbtn {
    padding-left: 105px !important;
    padding-right: 105px !important;
    margin-left: 14px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #notregistredbtn {
    margin-bottom: 20px !important;
    margin-top: 10px !important;
    padding-left: 85px !important;
    padding-right: 85px !important;
  }

  #spaceregistred {
    margin-left: 3px !important;
  }
}

@media screen and (max-width: 1300px) and (min-width: 1240px) {
  #buttonaccedi {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 0px !important;
    margin-left: 55px !important;
  }

  #forgotpassbtn {
    padding-left: 80px !important;
    padding-right: 80px !important;
    margin-left: 15px !important;
  }

  #forgotuserbtn {
    padding-left: 80px !important;
    padding-right: 80px !important;
    margin-left: 14px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #notregistredbtn {
    margin-bottom: 20px !important;
    margin-top: 10px !important;
    padding-left: 67px !important;
    padding-right: 67px !important;
  }

  #spaceregistred {
    margin-left: 15px !important;
  }
}

@media screen and (max-width: 1240px) and (min-width: 1200px) {
  #buttonaccedi {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 0px !important;
    margin-left: 55px !important;
  }

  #forgotpassbtn {
    padding-left: 80px !important;
    padding-right: 80px !important;
    margin-left: 15px !important;
  }

  #forgotuserbtn {
    padding-left: 80px !important;
    padding-right: 80px !important;
    margin-left: 14px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #notregistredbtn {
    margin-bottom: 20px !important;
    margin-top: 10px !important;
    padding-left: 60px !important;
    padding-right: 60px !important;
  }

  #spaceregistred {
    margin-left: 15px !important;
  }
}

@media screen and (max-width: 1200px) and (min-width: 1160px) {
  #buttonaccedi {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 0px !important;
    margin-left: 55px !important;
  }

  #forgotpassbtn {
    padding-left: 80px !important;
    padding-right: 80px !important;
    margin-left: 15px !important;
  }

  #forgotuserbtn {
    padding-left: 80px !important;
    padding-right: 80px !important;
    margin-left: 14px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #notregistredbtn {
    margin-bottom: 20px !important;
    margin-top: 10px !important;
    padding-left: 60px !important;
    padding-right: 60px !important;
  }

  #spaceregistred {
    margin-left: 8px !important;
  }
}

@media screen and (max-width: 1160px) and (min-width: 1130px) {
  #buttonaccedi {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 0px !important;
    margin-left: 55px !important;
  }

  #forgotpassbtn {
    padding-left: 63px !important;
    padding-right: 63px !important;
    margin-left: 15px !important;
  }

  #forgotuserbtn {
    padding-left: 63px !important;
    padding-right: 63px !important;
    margin-left: 14px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #notregistredbtn {
    margin-bottom: 20px !important;
    margin-top: 10px !important;
    padding-left: 47px !important;
    padding-right: 47px !important;
  }

  #spaceregistred {
    margin-left: 15px !important;
  }
}

@media screen and (max-width: 1130px) and (min-width: 1090px) {
  #buttonaccedi {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 0px !important;
    margin-left: 55px !important;
  }

  #forgotpassbtn {
    padding-left: 63px !important;
    padding-right: 63px !important;
    margin-left: 15px !important;
  }

  #forgotuserbtn {
    padding-left: 63px !important;
    padding-right: 63px !important;
    margin-left: 14px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #notregistredbtn {
    margin-bottom: 20px !important;
    margin-top: 10px !important;
    padding-left: 47px !important;
    padding-right: 47px !important;
  }

  #spaceregistred {
    margin-left: 8px !important;
  }
}

@media screen and (max-width: 1090px) and (min-width: 1050px) {
  #buttonaccedi {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 0px !important;
    margin-left: 55px !important;
  }

  #forgotpassbtn {
    padding-left: 52px !important;
    padding-right: 52px !important;
    margin-left: 15px !important;
  }

  #forgotuserbtn {
    padding-left: 52px !important;
    padding-right: 52px !important;
    margin-left: 14px !important;
  }

  #titlenotreg {
    margin-left: 15px !important;
  }

  #notregistredbtn {
    margin-bottom: 20px !important;
    margin-top: 10px !important;
    padding-left: 35px !important;
    padding-right: 35px !important;
  }

  #spaceregistred {
    margin-left: 0px !important;
  }
}

@media screen and (max-width: 1050px) and (min-width: 1000px) {
  #buttonaccedi {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 0px !important;
    margin-left: 55px !important;
  }

  #forgotpassbtn {
    padding-left: 45px !important;
    padding-right: 45px !important;
    margin-left: 15px !important;
  }

  #forgotuserbtn {
    padding-left: 45px !important;
    padding-right: 45px !important;
    margin-left: 14px !important;
  }

  #titlenotreg {
    margin-left: 15px !important;
  }

  #notregistredbtn {
    margin-bottom: 20px !important;
    margin-top: 10px !important;
    padding-left: 28px !important;
    padding-right: 28px !important;
  }

  #spaceregistred {
    margin-left: 0px !important;
  }
}

@media screen and (max-width: 1000px) and (min-width: 960px) {
  #buttonaccedi {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 0px !important;
    margin-left: 55px !important;
  }

  #forgotpassbtn {
    padding-left: 35px !important;
    padding-right: 35px !important;
    margin-left: 15px !important;
  }

  #forgotuserbtn {
    padding-left: 35px !important;
    padding-right: 35px !important;
    margin-left: 14px !important;
  }

  #titlenotreg {
    margin-left: 15px !important;
  }

  #notregistredbtn {
    margin-bottom: 20px !important;
    margin-top: 10px !important;
    padding-left: 20px !important;
    padding-right: 20px !important;
  }

  #spaceregistred {
    margin-left: 0px !important;
  }
}

@media screen and (max-width: 959px) and (min-width: 950px) {
  #buttonaccedi {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 0px !important;
    margin-left: 55px !important;
  }

  #forgotpassbtn {
    padding-left: 110px !important;
    padding-right: 110px !important;
    margin-left: 15px !important;
  }

  #forgotuserbtn {
    padding-left: 110px !important;
    padding-right: 110px !important;
    margin-left: 14px !important;
  }

  #titlenotreg {
    margin-left: 15px !important;
  }

  #notregistredbtn {
    margin-bottom: 20px !important;
    margin-top: 0px !important;
    margin-left: 60px !important;
    padding-left: 95px !important;
    padding-right: 95px !important;
  }

  #spaceregistred {
    margin-left: 0px !important;
  }
}

@media screen and (max-width: 950px) and (min-width: 920px) {
  #buttonaccedi {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 0px !important;
    margin-left: 55px !important;
  }

  #forgotpassbtn {
    padding-left: 110px !important;
    padding-right: 110px !important;
    margin-left: 15px !important;
  }

  #forgotuserbtn {
    padding-left: 110px !important;
    padding-right: 110px !important;
    margin-left: 14px !important;
  }

  #titlenotreg {
    margin-left: 15px !important;
  }

  #notregistredbtn {
    margin-bottom: 20px !important;
    margin-top: 20px !important;
    margin-left: 50px !important;
    padding-left: 95px !important;
    padding-right: 95px !important;
  }

  #spaceregistred {
    margin-left: 0px !important;
  }
}

@media screen and (max-width: 920px) and (min-width: 900px) {
  #buttonaccedi {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 0px !important;
    margin-left: 55px !important;
  }

  #forgotpassbtn {
    padding-left: 110px !important;
    padding-right: 110px !important;
    margin-left: 15px !important;
  }

  #forgotuserbtn {
    padding-left: 110px !important;
    padding-right: 110px !important;
    margin-left: 14px !important;
  }

  #titlenotreg {
    margin-left: 15px !important;
  }

  #notregistredbtn {
    margin-bottom: 20px !important;
    margin-top: 20px !important;
    margin-left: 40px !important;
    padding-left: 95px !important;
    padding-right: 95px !important;
  }

  #spaceregistred {
    margin-left: 0px !important;
  }
}

@media screen and (max-width: 900px) and (min-width: 880px) {
  #buttonaccedi {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 0px !important;
    margin-left: 55px !important;
  }

  #forgotpassbtn {
    padding-left: 110px !important;
    padding-right: 110px !important;
    margin-left: 15px !important;
  }

  #forgotuserbtn {
    padding-left: 110px !important;
    padding-right: 110px !important;
    margin-left: 14px !important;
  }

  #titlenotreg {
    margin-left: 15px !important;
  }

  #notregistredbtn {
    margin-bottom: 20px !important;
    margin-top: 20px !important;
    margin-left: 30px !important;
    padding-left: 95px !important;
    padding-right: 95px !important;
  }

  #spaceregistred {
    margin-left: 0px !important;
  }
}

@media screen and (max-width: 880px) and (min-width: 850px) {
  #buttonaccedi {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 0px !important;
    margin-left: 55px !important;
  }

  #forgotpassbtn {
    padding-left: 110px !important;
    padding-right: 110px !important;
    margin-left: 15px !important;
  }

  #forgotuserbtn {
    padding-left: 110px !important;
    padding-right: 110px !important;
    margin-left: 14px !important;
  }

  #titlenotreg {
    margin-left: 15px !important;
  }

  #notregistredbtn {
    margin-bottom: 20px !important;
    margin-top: 20px !important;
    margin-left: 20px !important;
    padding-left: 95px !important;
    padding-right: 95px !important;
  }

  #spaceregistred {
    margin-left: 0px !important;
  }
}

@media screen and (max-width: 850px) and (min-width: 800px) {
  #buttonaccedi {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 0px !important;
    margin-left: 55px !important;
  }

  #forgotpassbtn {
    padding-left: 110px !important;
    padding-right: 110px !important;
    margin-left: 15px !important;
  }

  #forgotuserbtn {
    padding-left: 110px !important;
    padding-right: 110px !important;
    margin-left: 14px !important;
  }

  #titlenotreg {
    margin-left: 15px !important;
  }

  #notregistredbtn {
    margin-bottom: 20px !important;
    margin-top: 20px !important;
    margin-left: 8px !important;
    padding-left: 93px !important;
    padding-right: 93px !important;
  }

  #spaceregistred {
    margin-left: 0px !important;
  }
}

/*Specific Responsive Screen 800px*/

@media only screen and (max-width: 800px) {
  #buttonaccedi {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 20px !important;
    margin-left: 55px !important;
  }

  #forgotpassbtn {
    padding-left: 102px !important;
    padding-right: 110px !important;
    margin-left: 15px !important;
  }

  #forgotuserbtn {
    padding-left: 105px !important;
    padding-right: 105px !important;
    margin-left: 14px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #notregistredbtn {
    margin-bottom: 20px !important;
    margin-left: 20px !important;
    padding-left: 40px !important;
    padding-right: 40px !important;
  }
}

/*End Specific Responsive Screen 800px*/

@media screen and (max-width: 799px) and (min-width: 740px) {
  #buttonaccedi {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 20px !important;
    margin-left: 55px !important;
  }

  #forgotpassbtn {
    padding-left: 102px !important;
    padding-right: 110px !important;
    margin-left: 15px !important;
  }

  #forgotuserbtn {
    padding-left: 105px !important;
    padding-right: 105px !important;
    margin-left: 14px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #notregistredbtn {
    margin-bottom: 20px !important;
    margin-left: 20px !important;
    padding-left: 40px !important;
    padding-right: 40px !important;
  }
}

@media screen and (max-width: 740px) and (min-width: 700px) {
  #buttonaccedi {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 20px !important;
    margin-left: 55px !important;
  }

  #forgotpassbtn {
    padding-left: 102px !important;
    padding-right: 110px !important;
    margin-left: 15px !important;
  }

  #forgotuserbtn {
    padding-left: 105px !important;
    padding-right: 105px !important;
    margin-left: 14px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #notregistredbtn {
    margin-bottom: 20px !important;
    margin-left: 20px !important;
    padding-left: 50px !important;
    padding-right: 50px !important;
  }
}

@media screen and (max-width: 700px) and (min-width: 660px) {
  #buttonaccedi {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 20px !important;
    margin-left: 55px !important;
  }

  #forgotpassbtn {
    padding-left: 102px !important;
    padding-right: 110px !important;
    margin-left: 15px !important;
  }

  #forgotuserbtn {
    padding-left: 105px !important;
    padding-right: 105px !important;
    margin-left: 14px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #notregistredbtn {
    margin-bottom: 20px !important;
    margin-left: 10px !important;
    padding-left: 50px !important;
    padding-right: 50px !important;
  }
}

@media screen and (max-width: 660px) and (min-width: 600px) {
  #buttonaccedi {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 20px !important;
    margin-left: 55px !important;
  }

  #forgotpassbtn {
    padding-left: 102px !important;
    padding-right: 110px !important;
    margin-left: 15px !important;
  }

  #forgotuserbtn {
    padding-left: 105px !important;
    padding-right: 105px !important;
    margin-left: 14px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #notregistredbtn {
    margin-bottom: 20px !important;
    margin-left: 5px !important;
    padding-left: 45px !important;
    padding-right: 45px !important;
  }
}

@media screen and (max-width: 600px) and (min-width: 570px) {
  #buttonaccedi {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 20px !important;
    margin-left: 55px !important;
  }

  #forgotpassbtn {
    padding-left: 102px !important;
    padding-right: 110px !important;
    margin-left: 15px !important;
  }

  #forgotuserbtn {
    padding-left: 105px !important;
    padding-right: 105px !important;
    margin-left: 14px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #notregistredbtn {
    margin-bottom: 20px !important;
    margin-left: 2px !important;
    padding-left: 35px !important;
    padding-right: 35px !important;
  }
}

@media screen and (max-width: 570px) and (min-width: 550px) {
  #buttonaccedi {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 20px !important;
    margin-left: 55px !important;
  }

  #forgotpassbtn {
    padding-left: 102px !important;
    padding-right: 110px !important;
    margin-left: 15px !important;
  }

  #forgotuserbtn {
    padding-left: 105px !important;
    padding-right: 105px !important;
    margin-left: 14px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #notregistredbtn {
    margin-bottom: 20px !important;
    margin-left: 1px !important;
    padding-left: 30px !important;
    padding-right: 30px !important;
  }
}

@media screen and (max-width: 550px) and (min-width: 530px) {
  #buttonaccedi {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 20px !important;
    margin-left: 55px !important;
  }

  #forgotpassbtn {
    padding-left: 102px !important;
    padding-right: 110px !important;
    margin-left: 15px !important;
  }

  #forgotuserbtn {
    padding-left: 105px !important;
    padding-right: 105px !important;
    margin-left: 14px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #notregistredbtn {
    margin-bottom: 20px !important;
    margin-left: 1px !important;
    padding-left: 20px !important;
    padding-right: 20px !important;
  }
}

@media screen and (max-width: 530px) and (min-width: 507px) {
  #buttonaccedi {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-right: 20px !important;
    margin-left: 55px !important;
  }

  #forgotpassbtn {
    padding-left: 102px !important;
    padding-right: 110px !important;
    margin-left: 15px !important;
  }

  #forgotuserbtn {
    padding-left: 105px !important;
    padding-right: 105px !important;
    margin-left: 14px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #notregistredbtn {
    margin-bottom: 20px !important;
    margin-left: 1px !important;
    padding-left: 10px !important;
    padding-right: 10px !important;
  }
}

@media screen and (max-width: 507px) and (min-width: 481px) {
  #buttonaccedi {
    padding-left: 180px !important;
    padding-right: 180px !important;
    margin-right: 5px !important;
    margin-left: 5px !important;
  }

  #forgotpassbtn {
    padding-left: 102px !important;
    padding-right: 110px !important;
    margin-left: 15px !important;
  }

  #forgotuserbtn {
    padding-left: 105px !important;
    padding-right: 105px !important;
    margin-left: 14px !important;
  }

  #divider {
    margin-top: 30px !important;
    margin-bottom: 40px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #notregistredbtn {
    margin-top: 20px !important;
    margin-bottom: 40px !important;
    margin-right: 0px !important;
    margin-left: 0px !important;
    padding-left: 87px !important;
    padding-right: 87px !important;
  }
}

/*Specific Responsive Screen 480px*/

@media only screen and (max-width: 480px) {
  #buttonaccedi {
    padding-left: 180px !important;
    padding-right: 180px !important;
    margin-right: 1px !important;
    margin-left: 1px !important;
  }

  #forgotpassbtn {
    padding-left: 102px !important;
    padding-right: 110px !important;
    margin-left: 15px !important;
  }

  #forgotuserbtn {
    padding-left: 105px !important;
    padding-right: 105px !important;
    margin-left: 14px !important;
  }

  #divider {
    margin-top: 30px !important;
    margin-bottom: 40px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #notregistredbtn {
    margin-top: 20px !important;
    margin-bottom: 40px !important;
    margin-right: 0px !important;
    margin-left: 0px !important;
    padding-left: 87px !important;
    padding-right: 87px !important;
  }
}

/*End Specific Responsive Screen 480px*/

@media screen and (max-width: 479px) and (min-width: 460px) {
  #buttonaccedi {
    padding-left: 165px !important;
    padding-right: 165px !important;
    margin-right: 5px !important;
    margin-left: 5px !important;
  }

  #forgotpassbtn {
    padding-left: 90px !important;
    padding-right: 90px !important;
    margin-left: 15px !important;
  }

  #forgotuserbtn {
    padding-left: 90px !important;
    padding-right: 90px !important;
    margin-left: 14px !important;
  }

  #divider {
    margin-top: 30px !important;
    margin-bottom: 40px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #notregistredbtn {
    margin-top: 20px !important;
    margin-bottom: 40px !important;
    margin-right: 0px !important;
    margin-left: 0px !important;
    padding-left: 73px !important;
    padding-right: 73px !important;
  }

  #spaceregistred {
    margin-left: 26px !important;
  }
}

/*Specific Responsive Screen 460px*/

@media only screen and (max-width: 460px) {
  #buttonaccedi {
    padding-left: 165px !important;
    padding-right: 165px !important;
    margin-right: 5px !important;
    margin-left: 5px !important;
  }

  #forgotpassbtn {
    padding-left: 90px !important;
    padding-right: 90px !important;
    margin-left: 15px !important;
  }

  #forgotuserbtn {
    padding-left: 90px !important;
    padding-right: 90px !important;
    margin-left: 14px !important;
  }

  #divider {
    margin-top: 30px !important;
    margin-bottom: 40px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #notregistredbtn {
    margin-top: 20px !important;
    margin-bottom: 40px !important;
    margin-right: 0px !important;
    margin-left: 0px !important;
    padding-left: 73px !important;
    padding-right: 73px !important;
  }

  #spaceregistred {
    margin-left: 20px !important;
  }
}

/*End Specific Responsive Screen 460px*/

@media screen and (max-width: 459px) and (min-width: 440px) {
  #buttonaccedi {
    padding-left: 165px !important;
    padding-right: 165px !important;
    margin-right: 5px !important;
    margin-left: 5px !important;
  }

  #forgotpassbtn {
    padding-left: 90px !important;
    padding-right: 90px !important;
    margin-left: 15px !important;
  }

  #forgotuserbtn {
    padding-left: 90px !important;
    padding-right: 90px !important;
    margin-left: 14px !important;
  }

  #divider {
    margin-top: 30px !important;
    margin-bottom: 40px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #notregistredbtn {
    margin-top: 20px !important;
    margin-bottom: 40px !important;
    margin-right: 0px !important;
    margin-left: 0px !important;
    padding-left: 73px !important;
    padding-right: 73px !important;
  }

  #spaceregistred {
    margin-left: 10px !important;
  }
}

@media screen and (max-width: 440px) and (min-width: 436px) {
  #buttonaccedi {
    padding-left: 155px !important;
    padding-right: 155px !important;
    margin-right: 5px !important;
    margin-left: 5px !important;
  }

  #forgotpassbtn {
    padding-left: 80px !important;
    padding-right: 80px !important;
    margin-left: 15px !important;
  }

  #forgotuserbtn {
    padding-left: 80px !important;
    padding-right: 80px !important;
    margin-left: 14px !important;
  }

  #divider {
    margin-top: 30px !important;
    margin-bottom: 40px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #notregistredbtn {
    margin-top: 20px !important;
    margin-bottom: 40px !important;
    margin-right: 0px !important;
    margin-left: 0px !important;
    padding-left: 73px !important;
    padding-right: 73px !important;
  }

  #spaceregistred {
    margin-left: 10px !important;
  }
}

/*Specific Responsive Screen 435px*/

@media only screen and (max-width: 435px) {
  #buttonaccedi {
    padding-left: 155px !important;
    padding-right: 155px !important;
    margin-right: 0px !important;
    margin-left: 0px !important;
  }

  #forgotpassbtn {
    padding-left: 80px !important;
    padding-right: 80px !important;
    margin-right: 2px !important;
    margin-left: 2px !important;
  }

  #forgotuserbtn {
    padding-left: 80px !important;
    padding-right: 80px !important;
    margin-right: 2px !important;
    margin-left: 2px !important;
  }

  #divider {
    margin-top: 30px !important;
    margin-bottom: 40px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #notregistredbtn {
    margin-top: 20px !important;
    margin-bottom: 40px !important;
    margin-left: 0px !important;
    margin-right: 0px !important;
    padding-left: 63px !important;
    padding-right: 63px !important;
  }

  #spaceregistred {
    margin-left: 12px !important;
  }
}

/*End Specific Responsive Screen 435px*/

@media screen and (max-width: 434px) and (min-width: 424px) {
  #buttonaccedi {
    padding-left: 155px !important;
    padding-right: 155px !important;
    margin-right: 0px !important;
    margin-left: 0px !important;
  }

  #forgotpassbtn {
    padding-left: 80px !important;
    padding-right: 80px !important;
    margin-right: 2px !important;
    margin-left: 2px !important;
  }

  #forgotuserbtn {
    padding-left: 80px !important;
    padding-right: 80px !important;
    margin-right: 2px !important;
    margin-left: 2px !important;
  }

  #divider {
    margin-top: 30px !important;
    margin-bottom: 40px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #notregistredbtn {
    margin-top: 20px !important;
    margin-bottom: 40px !important;
    margin-left: 0px !important;
    margin-right: 0px !important;
    padding-left: 63px !important;
    padding-right: 63px !important;
  }

  #spaceregistred {
    margin-left: 12px !important;
  }
}

@media screen and (max-width: 424px) and (min-width: 413px) {
  #buttonaccedi {
    padding-left: 145px !important;
    padding-right: 145px !important;
    margin-right: 0px !important;
    margin-left: 0px !important;
  }

  #forgotpassbtn {
    padding-left: 70px !important;
    padding-right: 70px !important;
    margin-right: 2px !important;
    margin-left: 2px !important;
  }

  #forgotuserbtn {
    padding-left: 70px !important;
    padding-right: 70px !important;
    margin-right: 2px !important;
    margin-left: 2px !important;
  }

  #divider {
    margin-top: 30px !important;
    margin-bottom: 40px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #notregistredbtn {
    margin-top: 20px !important;
    margin-bottom: 40px !important;
    margin-left: 0px !important;
    margin-right: 0px !important;
    padding-left: 57px !important;
    padding-right: 57px !important;
  }

  #spaceregistred {
    margin-left: 12px !important;
  }
}

/*Specific Responsive Screen 412&411px*/

@media screen and (max-width: 412px) and (min-width: 411px) {
  #buttonaccedi {
    padding-left: 140px !important;
    padding-right: 140px !important;
    margin-right: 0px !important;
    margin-left: 0px !important;
  }

  #forgotpassbtn {
    padding-left: 65px !important;
    padding-right: 65px !important;
    margin-right: 2px !important;
    margin-left: 2px !important;
  }

  #forgotuserbtn {
    padding-left: 65px !important;
    padding-right: 65px !important;
    margin-right: 2px !important;
    margin-left: 2px !important;
  }

  #divider {
    margin-top: 30px !important;
    margin-bottom: 40px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #notregistredbtn {
    margin-top: 20px !important;
    margin-bottom: 40px !important;
    margin-left: 0px !important;
    margin-right: 0px !important;
    padding-left: 50px !important;
    padding-right: 50px !important;
  }

  #spaceregistred {
    margin-left: 12px !important;
  }
}

/*End Specific Responsive Screen 412&411px*/

@media screen and (max-width: 410px) and (min-width: 390px) {
  #buttonaccedi {
    padding-left: 140px !important;
    padding-right: 140px !important;
    margin-right: 0px !important;
    margin-left: 0px !important;
  }

  #forgotpassbtn {
    padding-left: 65px !important;
    padding-right: 65px !important;
    margin-right: 2px !important;
    margin-left: 2px !important;
  }

  #forgotuserbtn {
    padding-left: 65px !important;
    padding-right: 65px !important;
    margin-right: 2px !important;
    margin-left: 2px !important;
  }

  #divider {
    margin-top: 30px !important;
    margin-bottom: 40px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #notregistredbtn {
    margin-top: 20px !important;
    margin-bottom: 40px !important;
    margin-left: 0px !important;
    margin-right: 0px !important;
    padding-left: 50px !important;
    padding-right: 50px !important;
  }

  #spaceregistred {
    margin-left: 12px !important;
  }
}

@media screen and (max-width: 390px) and (min-width: 370px) {
  #buttonaccedi {
    padding-left: 130px !important;
    padding-right: 130px !important;
    margin-right: 0px !important;
    margin-left: 0px !important;
  }

  #forgotpassbtn {
    padding-left: 55px !important;
    padding-right: 55px !important;
    margin-right: 2px !important;
    margin-left: 2px !important;
  }

  #forgotuserbtn {
    padding-left: 55px !important;
    padding-right: 55px !important;
    margin-right: 2px !important;
    margin-left: 2px !important;
  }

  #divider {
    margin-top: 30px !important;
    margin-bottom: 40px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #notregistredbtn {
    margin-top: 20px !important;
    margin-bottom: 40px !important;
    margin-left: 0px !important;
    margin-right: 0px !important;
    padding-left: 40px !important;
    padding-right: 40px !important;
  }

  #spaceregistred {
    margin-left: 13px !important;
  }
}

/*Specific Responsive Screen 375px*/

@media only screen and (max-width: 375px) {
  #buttonaccedi {
    padding-left: 120px !important;
    padding-right: 120px !important;
    margin-right: 0px !important;
    margin-left: 0px !important;
  }

  #forgotpassbtn {
    padding-left: 44px !important;
    padding-right: 44px !important;
    margin-right: 2px !important;
    margin-left: 2px !important;
  }

  #forgotuserbtn {
    padding-left: 44px !important;
    padding-right: 44px !important;
    margin-right: 2px !important;
    margin-left: 2px !important;
  }

  #divider {
    margin-top: 30px !important;
    margin-bottom: 40px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #notregistredbtn {
    margin-top: 20px !important;
    margin-bottom: 40px !important;
    margin-left: 0px !important;
    margin-right: 0px !important;
    padding-left: 30px !important;
    padding-right: 30px !important;
  }

  #spaceregistred {
    margin-left: 13px !important;
  }
}

/*End Specific Responsive Screen 375px*/

@media screen and (max-width: 370px) and (min-width: 350px) {
  #buttonaccedi {
    padding-left: 120px !important;
    padding-right: 120px !important;
    margin-right: 0px !important;
    margin-left: 0px !important;
  }

  #forgotpassbtn {
    padding-left: 44px !important;
    padding-right: 44px !important;
    margin-right: 2px !important;
    margin-left: 2px !important;
  }

  #forgotuserbtn {
    padding-left: 44px !important;
    padding-right: 44px !important;
    margin-right: 2px !important;
    margin-left: 2px !important;
  }

  #divider {
    margin-top: 30px !important;
    margin-bottom: 40px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #notregistredbtn {
    margin-top: 20px !important;
    margin-bottom: 40px !important;
    margin-left: 0px !important;
    margin-right: 0px !important;
    padding-left: 30px !important;
    padding-right: 30px !important;
  }

  #spaceregistred {
    margin-left: 13px !important;
  }
}

@media screen and (max-width: 350px) and (min-width: 330px) {
  #buttonaccedi {
    padding-left: 110px !important;
    padding-right: 110px !important;
    margin-right: 0px !important;
    margin-left: 0px !important;
  }

  #forgotpassbtn {
    padding-left: 35px !important;
    padding-right: 35px !important;
    margin-right: 2px !important;
    margin-left: 2px !important;
  }

  #forgotuserbtn {
    padding-left: 35px !important;
    padding-right: 35px !important;
    margin-right: 2px !important;
    margin-left: 2px !important;
  }

  #divider {
    margin-top: 30px !important;
    margin-bottom: 40px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #notregistredbtn {
    margin-top: 20px !important;
    margin-bottom: 40px !important;
    margin-left: 0px !important;
    margin-right: 0px !important;
    padding-left: 20px !important;
    padding-right: 20px !important;
  }

  #spaceregistred {
    margin-left: 13px !important;
  }
}

@media screen and (max-width: 330px) and (min-width: 300px) {
  #buttonaccedi {
    padding-left: 95px !important;
    padding-right: 95px !important;
    margin-right: 0px !important;
    margin-left: 0px !important;
  }

  #forgotpassbtn {
    padding-left: 20px !important;
    padding-right: 20px !important;
    margin-right: 2px !important;
    margin-left: 2px !important;
  }

  #forgotuserbtn {
    padding-left: 20px !important;
    padding-right: 20px !important;
    margin-right: 2px !important;
    margin-left: 2px !important;
  }

  #divider {
    margin-top: 30px !important;
    margin-bottom: 40px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #notregistredbtn {
    margin-top: 20px !important;
    margin-bottom: 40px !important;
    margin-left: 0px !important;
    margin-right: 0px !important;
    padding-left: 10px !important;
    padding-right: 10px !important;
  }

  #spaceregistred {
    margin-left: 13px !important;
  }
}

@media screen and (max-width: 300px) and (min-width: 270px) {
  #buttonaccedi {
    padding-left: 80px !important;
    padding-right: 80px !important;
    margin-right: 0px !important;
    margin-left: 0px !important;
  }

  #forgotpassbtn {
    padding-left: 7px !important;
    padding-right: 7px !important;
    margin-right: 0px !important;
    margin-left: 7px !important;
  }

  #forgotuserbtn {
    padding-left: 7px !important;
    padding-right: 7px !important;
    margin-right: 0px !important;
    margin-left: 7px !important;
  }

  #divider {
    margin-top: 30px !important;
    margin-bottom: 40px !important;
  }

  #titlenotreg {
    margin-left: 0px !important;
  }

  #notregistredbtn {
    margin-top: 20px !important;
    margin-bottom: 40px !important;
    margin-left: 0px !important;
    margin-right: 0px !important;
    padding-left: 1px !important;
    padding-right: 1px !important;
  }

  #spaceregistred {
    margin-left: 0px !important;
  }
}

/*Sizes less than 270px*/

@media screen and (max-width: 270px) and (min-width: 240px) {
  #buttonaccedi {
    padding-left: 66px !important;
    padding-right: 66px !important;
    margin-right: 9px !important;
    margin-left: 1px !important;
    font-size: 11px !important;
  }

  #forgotpassbtn {
    padding-left: 8px !important;
    padding-right: 8px !important;
    margin-right: 0px !important;
    margin-left: 0px !important;
    font-size: 11px !important;
  }

  #forgotuserbtn {
    padding-left: 8px !important;
    padding-right: 8px !important;
    margin-right: 0px !important;
    margin-left: 0px !important;
    font-size: 11px !important;
  }

  #divider {
    margin-top: 30px !important;
    margin-bottom: 40px !important;
  }

  #spaceregistred {
    margin-left: 0px !important;
    margin-right: 0px !important;
  }

  #titlenotreg {
    margin-left: 18px !important;
  }

  #notregistredbtn {
    margin-top: 20px !important;
    margin-bottom: 40px !important;
    margin-left: 0px !important;
    margin-right: 0px !important;
    padding-left: 15px !important;
    padding-right: 15px !important;
    font-size: 8.5px !important;
  }

  #spaceregistred {
    margin-left: 7px !important;
  }
}

@media screen and (max-width: 240px) {
  #buttonaccedi {
    padding-left: 66px !important;
    padding-right: 66px !important;
    margin-right: 9px !important;
    margin-left: 1px !important;
    font-size: 11px !important;
  }

  #forgotpassbtn {
    padding-left: 8px !important;
    padding-right: 8px !important;
    margin-right: 0px !important;
    margin-left: 0px !important;
    font-size: 11px !important;
  }

  #forgotuserbtn {
    padding-left: 8px !important;
    padding-right: 8px !important;
    margin-right: 0px !important;
    margin-left: 0px !important;
    font-size: 11px !important;
  }

  #divider {
    margin-top: 30px !important;
    margin-bottom: 40px !important;
  }

  #spaceregistred {
    margin-left: 0px !important;
    margin-right: 0px !important;
  }

  #titlenotreg {
    margin-left: 18px !important;
  }

  #notregistredbtn {
    margin-top: 20px !important;
    margin-bottom: 40px !important;
    margin-left: 0px !important;
    margin-right: 0px !important;
    padding-left: 15px !important;
    padding-right: 15px !important;
    font-size: 8.5px !important;
  }

  #spaceregistred {
    margin-left: 7px !important;
  }
}
</style>
